<template>
  <v-list-tile class="nx-selectable-list-item" :class="{ 'nx-active': selected }">
    <v-list-tile-avatar>
      <nx-media-image
        :src="thumbnailSrc"
        :alt="title"
        :info="icon"
      ></nx-media-image>
    </v-list-tile-avatar>

    <v-list-tile-content>
      <v-toolbar color="transparent" flat>
        <v-badge class="nx-badge ml-0" right>
          <span slot="badge">
            <span class="badge__item" v-for="badge in badges" :key="badge.title">
              {{ badge.title }}
            </span>
          </span>
          <v-toolbar-title>
            <router-link v-if="to" class="toolbar__title-link" :to="to">{{ title }}</router-link>
            <a v-else class="toolbar__title-link" @click="$emit('input')">{{ title }}</a>
          </v-toolbar-title>
        </v-badge>

        <v-spacer v-if="info || sortable"></v-spacer>

        <v-tooltip class="nx-tooltip" left v-if="info">
          <v-btn :title="title" icon slot="activator" small>
            <v-icon>info_outline</v-icon>
          </v-btn>
          <div class="nx-tooltip__content">
            <ul>
              <li v-for="(prop, index) in info" :key="index">
                <b>{{ prop.name }}:</b> {{ prop.value }}
              </li>
            </ul>
          </div>
        </v-tooltip>

        <slot name="options">
          <v-menu v-if="options">
            <v-btn slot="activator" icon small :title="title">
              <v-icon>more_vert</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile
                ripple
                :disabled="option.disabled"
                :key="option.title"
                :title="option.title"
                @click="optionClicked(option)"
                v-for="option in options"
              >
                <v-list-tile-action v-if="option.icon">
                  <v-icon>{{ option.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ option.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
        </slot>

      </v-toolbar>
    </v-list-tile-content>

    <v-list-tile-action v-if="sortable">
      <v-icon class="nx-drag-handle">drag_handle</v-icon>
    </v-list-tile-action>

  </v-list-tile>
</template>

<script>
import MediaImage from '@/components/media/MediaImage';

export default {
  name: 'nx-selectable-list-item',
  props: {
    badges: Array,
    info: Array,
    icon: String,
    options: Array,
    selected: Boolean,
    sortable: Boolean,
    thumbnailSrc: String,
    title: {
      type: String,
      required: true,
    },
    to: Object,
  },
  components: {
    [MediaImage.name]: MediaImage,
  },
  methods: {
    optionClicked(option) {
      if (option.callback && typeof option.callback === 'function') option.callback();
      else if (option.event) this.$emit('option', option.event);
    },
  },
};
</script>

<style lang="stylus">
  .nx-selectable-list-item {

    $button_fgColor = #8C8C9C;

    border-bottom: 1px solid rgba(#000, 0.12);
    transition: background-color 0.3s

    .btn .btn__content .icon {
      color: $button_fgColor;
    }
    &.nx-active {
      background-color: #EDEDF0
    }

    .list__tile {
      min-height: 130px;
    }

    .toolbar {
      .badge__badge {
        position: relative;
        margin-left: 10px;
      }
    }

    .toolbar__title {
      white-space: normal;

      .toolbar__title-link:hover {
        text-decoration: underline;
      }

      & ~ .badge__badge {
        margin-top: 20px;
      }
    }
    .toolbar__content {
      height: auto !important;
    }

    .toolbar__title-link {
      color: inherit;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    .toolbar__title {
      font-size: 14px;
      line-height: 18px;
    }

    .nx-drag-handle {
      opacity: 0.2;
      color: $button_fgColor;

      &:hover {
        opacity: 1;
      }
    }
  }
</style>
